<script lang="ts" setup>
import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
defineEmits(["update:modelValue"]);
import { computed } from 'vue';
import { KeyValuePair } from '@/helpers/Interfaces';
import { FormBuilderContract } from '@/components/builder/form';
import { ModuleOption } from '@/modules/studio/forms/services/FormsService';
import { Blueprint } from '@/components/builder/base/blueprints/Blueprint';
import { Definition as LogitoAttachmentSelection } from '../blueprints/logito-attachment-selection';
import { Definition as LogitoAttachments } from '../blueprints/logito-attachments';
import { Definition as LogitoDocument } from '../blueprints/logito-document';
import { Definition as LogitoRelatedDocuments } from '../blueprints/logito-related-documents';
import { Definition as LogitoTable } from '../blueprints/logito-table';
import { Definition as LogitoValidator } from '../blueprints/logito-validator';
import { Definition as LogitoVatTable } from '../blueprints/logito-vat-table';
import { Definition as LogitoDynamicModal } from '../blueprints/logito-dynamic-modal';
import { Definition as LogitoDocumentPreview } from '../blueprints/logito-document-preview';
import { Definition as LogitoField } from '../blueprints/logito-field';
import { Definition as LogitoDocumentList } from '../blueprints/logito-document-list';
import { Definition as LogitoDocumentDetails } from '../blueprints/logito-document-details';

const { modelValue } = __MACROS_useVModel("modelValue");

const props = defineProps({
  "modelValue": null,
  "form": null,
  "blueprint": null,
  "label": null,
  "selectedModules": null,
  "options": null,
  "isFilters": { type: Boolean,  }
});

const fields = computed(() =>
{
    return modelValue.value.map((p) => (components.value.find((item) => item.key === p)));
});

const components = computed(() =>
{
    const blackListOfTypes = [
        LogitoAttachmentSelection.type,
        LogitoAttachments.type,
        LogitoDocument.type,
        LogitoRelatedDocuments.type,
        LogitoTable.type,
        LogitoValidator.type,
        LogitoVatTable.type,
        LogitoDynamicModal.type,
        LogitoDocumentPreview.type,
        LogitoField.type,
        LogitoDocumentList.type,
        LogitoDocumentDetails.type
    ];

    return props.options.filter(p => !blackListOfTypes.some(q => (q + 'Type').toLowerCase().replace('-', '') === p.type.toLowerCase()));
});

const keyOptions = (option?: KeyValuePair) =>
{
    return components.value.filter(
        (p) => Object.keys(modelValue.value).includes(p.key) === false || p.key === option?.key
    );
};

const addField = () =>
{
    if (!keyOptions().length) return;

    modelValue.value.push('');
};

const updateFieldKey = (index: number, toKey: KeyValuePair) =>
{
    modelValue.value[index] = toKey.key;
};

const deleteField = (index: number) =>
{
    modelValue.value.splice(index, 1);
};
</script>

<template>
    <div class="form-group">
        <label v-if="label">{{ $t(label) }}</label>
        <div v-for="(item, index) in fields" :key="index" class="d-flex mb-1">
            <div class="d-flex gap-1 flex-fill">
                <ideo-select
                    :model-value="item"
                    :clear-button="false"
                    :options="components"
                    :narrow-options="{ item: item }"
                    class="w-100"
                    @update:model-value="updateFieldKey(index, $event)"
                />
            </div>
            <div class="input-group-append d-flex ms-1">
                <button type="button" class="btn btn-outline-light" @click="deleteField(index)">
                    <i class="far fa-trash text-danger"></i>
                </button>
            </div>
        </div>
        <button class="btn btn-outline-light w-100" type="button" :disabled="!keyOptions().length" @click="addField">
            <i class="far fa-plus text-success"></i>
        </button>
    </div>
</template>
